<template>
  <div class="hello">
    <nav class="flex items-center justify-between flex-wrap bg-red-600 p-6">
      <div class="flex items-center flex-shrink-0 text-white mr-6">
        <svg
          class="fill-current h-8 w-8 mr-2"
          width="54"
          height="54"
          viewBox="0 0 54 54"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"
          />
        </svg>
        <span class="font-semibold text-xl tracking-tight">{{title}}</span>
      </div>
      <div class="block lg:hidden">
        <button
          class="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white"
          @click="openNavOptions()"
        >
          <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <title v-if="isNavOptionsOpen">Close</title>
            <title v-else>Menu</title>
            <path v-if="isNavOptionsOpen" d="M11.469,10l7.08-7.08c0.406-0.406,0.406-1.064,0-1.469c-0.406-0.406-1.063-0.406-1.469,0L10,8.53l-7.081-7.08
							c-0.406-0.406-1.064-0.406-1.469,0c-0.406,0.406-0.406,1.063,0,1.469L8.531,10L1.45,17.081c-0.406,0.406-0.406,1.064,0,1.469
							c0.203,0.203,0.469,0.304,0.735,0.304c0.266,0,0.531-0.101,0.735-0.304L10,11.469l7.08,7.081c0.203,0.203,0.469,0.304,0.735,0.304
							c0.267,0,0.532-0.101,0.735-0.304c0.406-0.406,0.406-1.064,0-1.469L11.469,10z" />
            <path v-else d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto" v-if="isNavOptionsOpen">
        <div class="text-sm lg:flex-grow">
          <router-link v-for="nav in navOptions"
            :key="nav.name"
            :to="nav.route"
            class="block mt-4 lg:inline-block lg:mt-0 text-black font-bold hover:text-white mr-4"
            active-class="bg-black p-2 rounded-md text-white" exact
          >{{ nav.name }}</router-link>
        </div>
      </div>
    </nav>
    <div class="bg-black-900"></div>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      title: "backtoschool",
      isNavOptionsOpen: window.innerWidth >= 1024,
      navOptions: [
        {
          name:"Timeline",
          route:"/"
        },
        {
          name:"Profiles",
          route:"/profiles"
        },
        {
          name:"Foreword",
          route:"/#"
        },
        {
          name:"Credits",
          route:"/credits"
        },
        {
          name:"Blogs",
          route:"/#"
        },
      ]
    };
  },
  created() {
    window.addEventListener(
      'resize',
      this.openNavOptions
    )
  },
  methods: {
    openNavOptions(){
      if(window.innerWidth >= 1024)
        this.isNavOptionsOpen = true
      else {
        //console.log('nav', this.isNavOptionsOpen)
        this.isNavOptionsOpen = !this.isNavOptionsOpen
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue